import fetchApi from "../fetchApi";

export const UpdateOffice = async ({id, company_id, name, address1, address2, postalCode, state, city, country, status}) => {
    const options = {
        method: 'PUT',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "company_id": company_id,
            "name": name,
            "address": address1,
            "address_additional": address2,
            "postal_code": postalCode,
            "state": state,
            "city": city,
            "country": country,
            "status" : status
        }),
        redirect: 'follow'
    }

    return await fetchApi(`offices/${id}`, options);
};